module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_couple_photo-59ee3aa177377b2aac6ce81adff12db0.jpg";